import React, { Component } from "react"

/* Cubago ep-ui */
import { Background, Balance, Internet, InactionTiming, GameInfo, Transactions, Error, Jackpot, BonusWin } from "@cuba-go/ep-ui"

/* Widgets */
import { PlayerCards, DealerCards, Joker, Rates, Chips, Result, Preloader } from './widgets'

/* Components */
import { Fold, Bet, Exchange, Start, Payout, Picture, Notification } from './components'

/* Socket IO */
import { io } from "socket.io-client"

/* JWT */
import { decodeToken } from 'react-jwt'

/* REST API */
import { history } from './api/History'

/* Constants */
import { env, utils, sound } from "./constants"
import { ERROR, CHOICE, DEALING, GAME, LOADING } from "./constants/status"

/* Rules */
import { rules } from "./constants/rules"

/* Redux */
import { connect } from 'react-redux'

/* Fields */
const pathname = window.location.search
const token = pathname.length > 1 ? pathname.substring(1) : ""

const imgUrl = 'https://repb.rekopgames.com/images/rules/game.png'


/* Entry Point */
class App extends Component {

    constructor() {
        super()

        const data = decodeToken(token)

        this.state = {
            status: LOADING,

            ante: 0,
            bonus: 0,
            selected: 0,
            last: { ante: 0, bonus: 0 },
            bet: 0,
            list: [],
            balance: 0,
            total: 0,
            lastWin: 0,

            solution: "",
            used: false,

            joker: null,
            playerCards: [],
            playerGame: null,
            exchanged: [],
            isExchange: false,

            dealerCards: [],
            dealerGame: null,

            result: null,
            bonusResult: null,
            chip: false,

            gameInfo: null,
            transactions: [],
            operations: [],
            histories: [],
            historyLoading: true,
            historyPage: 1,
            historyHasMore: true,

            showInternetConnectionError: 0,

            /* Game Session */
            closed: false,
            newDevice: false,
            isDisconnected: false,

            currency: data.currency,
            chips: utils.getChips(data.chips),
            game: {
                max: data.max,
                maxBonus: data.maxBonus,
                minBonus: data.minBonus,
                min: data.min,
                maxPay: data.maxPay
            },

            volume: false,
            locale: data.locale ? data.locale : "ru",
            isDemo: data.isDemo,

            operator: data.operator,
            withJackpot: data.withJackpot,
            jackpot: null,
            bonusWin: []
        }

        /* Start connection */
        this.socket = io(env.endpoint, { auth: { token: `${token}`, reconnection: false, isPlayer: true } })
        this._bonusTiming = null

    }

    componentDidMount = () => {

        const { locale } = this.state
        const { setLanguage } = this.props
        setLanguage(locale)

        this.game()
        this.loadHistory()
    }

    /* Load History */
    loadHistory = (page = 1) => {

        const { histories } = this.state

        if (page > 1) {
            this.setState({ historyPage: page })
        }

        history(token, page).then(response => {
            if (response.status === 200) {
                let list = response.data

                if (page > 1) {
                    list = [...histories, ...response.data]
                }

                if (response.data.length < 5) {
                    this.setState({ historyHasMore: false })
                }

                this.setState({ histories: list, historyLoading: false })
            }
        }).catch(() => {
            this.setState({ histories: [], historyLoading: false })
        })
    }


    game = () => {
        /* On error */
        this.socket.on("connect_error", () => {

            const timer = setTimeout(() => {
                this.setState({ status: ERROR })
                clearTimeout(timer)
            }, 1000)

        })

        /*  */
        this.socket.on("disconnect", () => {
            this.setState({ isDisconnected: true })
        })

        /* On connect */
        this.socket.on("connect", () => {
            const timer = setTimeout(() => {
                if (this.state.status !== CHOICE) {
                    this.setState({ status: CHOICE })
                    this.clear()
                }
                clearTimeout(timer)
            }, 2000)
        })

        /* On New Device */
        this.socket.on("newDeviceConnection", () => {
            this.setState({ newDevice: true })
            this.socket.disconnect()
        })


        /* Reconnection */
        this.socket.on("reconnection", data => {

            const time = data.transactionError ? 3500 : 2000

            if (data.transactionError) {
                utils.toggleError(utils.translate("Transaction error"))
            }

            if (data.error) {
                utils.toggleError(utils.translate("Something went wrong! Try again later or refresh the page."))
            }

            setTimeout(() => {
                this.setState({
                    status: data.status,
                    gameInfo: data.gameInfo,
                    ante: data.ante,
                    bonus: data.bonus,
                    total: data.total,
                    joker: data.joker,
                    playerCards: data.playerCards,
                    dealerCards: data.dealerCards,
                    exchanged: data.exchangeCards,
                    bet: data.bet,
                    pass: data.pass,
                    isExchange: data.isExchange,
                    used: data.used,
                    playerGame: data.playerGame,
                    dealerGame: data.dealerGame,
                    bonusResult: data.bonusResult,
                    result: data.result,

                    transactions: data.transactions
                })
            }, time)
        })

        /* On start */
        this.socket.on("status", data => {
            const { status } = this.state
            if (data !== status) {
                this.setState({ status: data })
            }

            if (data === CHOICE) {
                this.clear()
                this.loadHistory()
            }
        })


        /* Balance */
        this.socket.on("balance", data => {
            this.setState({ balance: data })
        })

        /* Get a dealer card */
        this.socket.on("dealer", data => {

            const { dealerCards, volume } = this.state
            const i = dealerCards.findIndex(e => e.uuid === data.uuid)
            let cards = dealerCards

            if (i === -1) {
                cards.push(data)
                this.setState({ dealerCards: cards })

                if (volume) {
                    sound.play('card', 0.2)
                }
            } else if (dealerCards[i].id && i !== 4) {
                let card = dealerCards[i]
                cards.splice(i, 1)
                cards.push(card)
                this.setState({ dealerCards: cards })
            }

            if (data.joker) {
                this.setState({ joker: data })
            }

        })

        this.socket.on("dealerData", data => {

            const { dealerCards, dealerGame, result } = data
            const { volume } = this.state

            this.setState({ dealerCards, dealerGame, result, lastWin: result && result.result === "win" && result.sum ? result.sum : 0 })

            if (result && (result.result === "win" || result.result === "draw")) {
                if (volume) {
                    sound.play('win', 0.2)
                }
            }
        })

        /* Get a Joker card */
        this.socket.on("joker", data => {
            const { joker, volume } = this.state
            if (!joker) {
                this.setState({ joker: data })

                if (volume) {
                    sound.play('card', 0.2)
                }
            }
        })

        /* Get a Player card */
        this.socket.on("player", data => {
            const { playerCards, volume } = this.state
            const i = playerCards.findIndex(e => e.uuid === data.uuid)
            if (i === -1) {
                let cards = playerCards
                cards.push(data)
                this.setState({ playerCards: cards })

                if (volume) {
                    sound.play('card', 0.2)
                }
            }
        })

        this.socket.on("playerGame", data => {
            this.setState({ playerGame: data, status: GAME })
        })

        /* Result */
        this.socket.on("bonusResult", bonusResult => {
            const { volume } = this.state

            this.setState({ bonusResult })

            if (bonusResult.result === "win") {

                if (volume) {
                    sound.play('winsmall', 0.2)
                }

                this.setState({ bonusWin: [{ ...bonusResult, box: 0 }] })

                const timer = setTimeout(() => {
                    this.setState({ bonusWin: [] })
                    clearTimeout(timer)
                }, 4000)

            }
        })

        /* Result */
        this.socket.on("result", result => {

            const { volume } = this.state

            this.setState({ result })

            if (result && result.result === "win") {
                this.setState({ lastWin: result.sum })
            }

            if (result && (result.result === "win" || result.result === "draw")) {
                if (volume) {
                    sound.play('win', 0.2)
                }
            }
        })

        /* Get Game Info */
        this.socket.on("gameInfo", data => {
            this.setState({ gameInfo: data })
        })

        /* Get transactions list */
        this.socket.on("transaction", data => {
            if (data.id) {
                const { operations } = this.state

                operations.push(data)
                this.setState({ operations })

                // setTimeout(() => {
                //     let operationsList = this.state.operations
                //     operationsList = operationsList.filter(item => item.id !== data.id)
                //     this.setState({ operations: operationsList })
                // }, 2000)

            }
        })

        this.socket.on("editTransaction", data => {
            const { operations } = this.state
            let list = operations
            const index = list.findIndex(e => e.number === data.number)
            if (index > -1) {
                list[index].status = data.status
                this.setState({ operations: list })
            }
        })


        /* Force End Game */
        this.socket.on("forceEnd", () => {
            this.setState({ status: CHOICE })
            this.loadHistory()
            this.clear()
            utils.toggleError(utils.translate("The game ended due to the administrator's initiative"), "warning")
        })

        /* Notification From Admin */
        this.socket.on("adminNotification", data => {
            if (data && data.title && data.total && data.currency) {
                utils.toggleError(`${utils.translate(data.title)} ${utils.getWithCurrency(data.total, data.currency)}`, "success")
                this.loadHistory()
            }
        })

        /* Jackpot */
        this.socket.on("jackpot", jackpot => {
            this.setState({ jackpot })
        })

    }

    /* Disconnect user when inaction timer equal to 0 */
    setInactionState = () => {
        this.setState({ closed: true })
        this.socket.disconnect()
        this.clear()
    }

    /* Reser top timing */
    resetTimer = () => {
        if (this._inaction) {
            this._inaction.reset()
        }
    }

    handleClose = (id) => {

        const { showInternetConnectionError } = this.state

        if (id === "internet" && showInternetConnectionError <= 2) {
            this.setState({ showInternetConnectionError: showInternetConnectionError + 1 })
            if (showInternetConnectionError + 1 === 2) {
                setTimeout(() => {
                    this.setState({ showInternetConnectionError: 1 })
                }, 300000)
            }
        }

    }

    /* Check internet speed */
    checkInternetSpeed = (speed) => {

        const { showInternetConnectionError } = this.state

        if (showInternetConnectionError < 2) {
            if (parseInt(speed) < 3) {
                utils.toggleError(utils.translate("Poor internet connection"), "warning", "internet", this.handleClose)
            }
            else {
                utils.toastDismiss('internet')
            }
        }

    }

    clear = () => {
        this.setState({
            ante: 0,
            bonus: 0,
            bet: 0,
            total: 0,
            list: [],
            gameInfo: null,

            solution: "",
            used: false,

            joker: null,
            playerCards: [],
            playerGame: null,
            exchanged: [],
            isExchange: false,

            dealerCards: [],
            dealerGame: null,

            result: null,
            bonusResult: null,

            operations: []
        })
    }

    setStake = (data) => {
        const { ante, bonus } = data
        this.setState({ ante, bonus, total: ante + bonus, lastWin: 0 })

        this.resetTimer()
    }

    start = () => {
        const { ante, bonus, game, currency } = this.state
        const stake = { ante, bonus }

        if (bonus > 0) {
            if (game.minBonus) {
                if (parseInt(game.minBonus) > bonus) {
                    utils.toggleError(`${utils.translate("Minimum bid for bonus")} ${utils.getWithCurrency(game.minBonus, currency)}`, "error", "maxbidbonus")
                    return
                }
            }
        }

        if (ante > 0) {
            this.setState({ status: "DEALING", last: stake })
            this.socket.emit('start', stake)
        }

        this.resetTimer()
    }


    /* FOLD ACTION */
    fold = () => {

        const { dealerCards, solution } = this.state

        if (solution !== "BET" && solution !== "FOLD") {

            if (dealerCards.length === 5) {
                this.socket.emit("pass", { status: "ok" })
            }

            this.setState({ solution: "FOLD", status: DEALING })

        }

        this.resetTimer()
    }


    /* BET ACTION */
    bet = () => {

        const { dealerCards, ante, total, isExchange, solution, volume } = this.state

        if (dealerCards.length === 5 && solution !== "BET" && solution !== "FOLD") {

            this.socket.emit("bet", { ok: "ok" })

            if (!isExchange) {
                this.setState({ exchanged: [] })
            }

            this.setState({ solution: "BET", bet: ante * 2, total: total + ante * 2, used: true, status: DEALING })

            if (volume) {
                sound.play('sound', 0.2)
            }

        }

        this.resetTimer()

    }


    /* EXCHANGE ACTION */
    exchange = () => {

        const { playerCards, used, exchanged, ante, total, volume, balance } = this.state

        if (playerCards.length === 5 && !used) {

            const eLength = exchanged.length

            if (eLength < 1 || eLength > 3) {
                utils.toggleError(utils.translate("You need to select from one to three cards."), "error", "exchange")
                return
            }

            if (balance - (ante * eLength) < ante * 2) {
                utils.toggleError(utils.translate("You don't have enough funds"), "error", "nomoney")
                return
            }

            this.socket.emit("exchange", exchanged)

            this.setState({ playerGame: null, isExchange: true, used: true, total: total + ante * eLength, status: DEALING })

            const animatedTimer = setTimeout(() => {
                this.setState({ chip: false })
                clearTimeout(animatedTimer)
            }, 2000)

            if (volume) {
                sound.play('sound', 0.2)
            }

            this.resetTimer()

        }

    }


    /* Game action */
    gameAction = (action) => {
        this.socket.emit("gameAction", action)
    }


    /* Draw Button */
    _buttons = () => {

        const { status, ante, playerCards, dealerCards, used, solution, isExchange } = this.state

        if (status === "GAME" && playerCards.length >= 5 && dealerCards.length === 5 && solution === "") {
            return (
                <div className={`buttons`}>
                    <Fold onClick={() => this.fold()} />
                    <Bet onClick={() => this.bet()} />
                    {!used && !isExchange && <Exchange onClick={() => this.exchange()} />}
                </div>
            )
        }

        if (status === "CHOICE") {
            return (
                <div className="buttons">
                    <Start onClick={() => this.start()} ante={ante} />
                </div>
            )
        }
    }

    /* Draw Content */
    _content = () => {

        /* Fields */
        const { status, ante, bonus, selected, last, list, joker, playerCards, playerGame, dealerCards, dealerGame, solution, balance, used, exchanged, isExchange, game, chips, currency, volume } = this.state

        return (
            <div className="content">

                <div className={`game ${status !== "CHOICE" ? "visible" : "hidden"}`}>
                    <DealerCards joker={joker} cards={dealerCards} game={dealerGame} playerCards={playerCards} solution={solution} />
                    <Joker joker={joker} solution={solution} />
                    <PlayerCards ante={ante} chips={chips} joker={joker} cards={playerCards} game={playerGame} solution={solution} used={used} exchanged={exchanged} setExchanged={exchanged => this.setState({ exchanged })} isExchange={isExchange} volume={volume} />
                </div>

                <div className={`choice ${status === "CHOICE" ? "visible" : "hidden"}`}>
                    <Chips
                        chips={chips}
                        ante={ante}
                        bonus={bonus}
                        setStake={data => this.setStake(data)}
                        last={last}
                        selected={selected}
                        setSelected={selected => this.setState({ selected })}
                        list={list}
                        setList={list => this.setState({ list })}
                        balance={balance}
                        game={game}
                        currency={currency}
                        volume={volume}
                    />
                </div>

            </div>
        )
    }

    /* Get Rules */
    getRules = () => {

        const { language } = this.props

        if (rules[language]) {
            return rules[language]
        }

        return rules["ru"]
    }

    render = () => {

        const { ante, bonus, selected, status, list, balance, solution, result, bonusResult, bet, total, lastWin, chip, currency, game, histories, historyHasMore, historyPage, operations, closed, newDevice, isDisconnected, chips, gameInfo, volume, jackpot, bonusWin, withJackpot, locale, operator, isDemo } = this.state

        const gameJackpot = withJackpot === "yes"

        const params = { mediapoint: `${env.mediapoint}`, type: "one-box", lang: locale, operator, isDemo }

        const payout = <Payout game={game} currency={currency} gameJackpot={gameJackpot} />

        const logo = operator !== "makao" ? "cubago.png" : "makao.png"

        const historyData = {
            histories,
            historyHasMore,
        }

        let newrule = this.getRules()
        if (!gameJackpot) {
            newrule = newrule.filter(e => e.type !== "bonus")
        }

        if (status === LOADING) {
            return <Preloader operator={operator} />
        }

        if (status === ERROR || newDevice || closed || isDisconnected) {
            return <Error newDevice={newDevice} closed={closed} isDisconnected={isDisconnected} params={params} />
        }

        return (
            <Background params={params} gameJackpot={gameJackpot} historyData={historyData} payout={payout} gameInfo={gameInfo} rules={newrule} loadMore={() => this.loadHistory(historyPage + 1)} volume={volume} setVolume={volume => this.setState({ volume })}>
                <div className="app">

                    {(bonusWin.length > 0 && gameJackpot) && <BonusWin data={bonusWin} currency={currency} />}

                    <InactionTiming time={240} ref={ref => this._inaction = ref} setInactionState={() => this.setInactionState()} />

                    <GameInfo
                        title="J-POKER"
                        game={game}
                        currency={currency}
                        payout={payout}
                        params={params}
                        close={() => this.gameAction("closeGame")}
                    />
                    <Balance
                        balance={balance}
                        total={total}
                        lastWin={lastWin}
                        currency={currency}
                        params={params}
                        openBalance={() => this.gameAction("openDepositModal")}
                    />

                    <Transactions
                        info={gameInfo}
                        operations={operations}
                        currency={currency}
                        params={params}
                    />

                    {/* JACKPOT */}
                    {gameJackpot && <Jackpot jackpot={jackpot} />}

                    {this._content()}

                    <Rates
                        chips={chips}
                        status={status}
                        ante={ante}
                        bonus={bonus}
                        result={result}
                        bonusResult={bonusResult}
                        bet={bet}
                        setStake={data => this.setStake(data)}
                        selected={selected}
                        list={list}
                        setList={list => this.setState({ list })}
                        solution={solution}
                        balance={balance}
                        chip={chip}
                        bottomBet={() => this.bet()}
                        game={game}
                        currency={currency}
                        volume={volume}
                        gameJackpot={gameJackpot}
                    />

                    {this._buttons()}

                    <Result result={result} currency={currency} />

                    <div className="back-outer">
                        <div className="background" />
                        <div className="glass" />
                        <div className="shadow" />
                    </div>


                    {
                        !result ?
                            <div className={`makao ${(status === GAME || status === DEALING) ? 'visible' : 'hidden'}`}>
                                <Picture src={`${env.mediapoint}/images/${logo}`} alt="Makao" />
                            </div>
                            : null
                    }

                    <Notification />

                    <Internet url={imgUrl} setInternetSpeed={data => this.checkInternetSpeed(data)} />

                </div>
            </Background>
        )
    }

}
const mapStateToProps = state => {
    return {
        language: state.language
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setLanguage: data => dispatch({ type: 'SET_LANGUAGE', payload: data })
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)